import { render, staticRenderFns } from "./ServiceProviderDossierDetail.vue?vue&type=template&id=210be9ad&"
import script from "./ServiceProviderDossierDetail.vue?vue&type=script&lang=js&"
export * from "./ServiceProviderDossierDetail.vue?vue&type=script&lang=js&"
import style0 from "./ServiceProviderDossierDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports